export const types = {};

export const initialState = {};

const Home = (state = initialState, action) => {
  switch (action.type) {
    default:
      return { ...state };
  }
};

export const actions = {};

export default Home;
